module.exports = __webpack_public_path__ + "static/img/logo.5c07a1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/lgis/logo.jpg
// module id = stEV
// module chunks = 23